<template>
  <div class="box">
    <!-- 顶部导航 start -->
    <nav-bar />
    <!-- banner start -->

    <div class="pcban">
      <banner
        :bannerSrc="bannerList.src"
        isnum="news"
      />
      <div class="text1 wow bounceInLeft animated">艺识代知识产权/Easytimes IP</div>
      <div class="text2 wow bounceInLeft animated">"一站式,全方位"知识产权专业服务平台</div>
      <div class="text3 wow bounceInLeft animated">Full-range IP Service Platform</div>
    </div>
    <div class="medban">
      <banner
        :bannerSrc="bannerList.srcmedban"
        isnum="news"
      />
      <div class="text1 wow bounceInLeft animated">艺识代知识产权/Easytimes IP</div>
      <div class="text2 wow bounceInLeft animated">"一站式,全方位"知识产权专业服务平台</div>
      <div class="text3 wow bounceInLeft animated">Full-range IP Service Platform</div>
    </div>
    <!-- title start -->
    <!-- <div class="wow bounceIn animated ywzs_title" data-wow-offset="10">
      <span>
        <img class="ywzs_img1" src="@/assets/images/yw_ico_1.png" />
        {{ lange == "ch" ? "国内团队" : "Domestic team" }}
        <img class="ywzs_img2" src="@/assets/images/yw_ico_1.png" />
      </span>
    </div> -->
    <!-- title end -->
    <!-- news list -->
    <news-list />
    <!-- img
    <img class="footImg" src="@/assets/images/zx_ico_4.png" />-->
    <!-- 页脚 start -->
    <footers />
  </div>
</template>

<script>
//最新资讯
import NavBar from "@/components/NavBar";
import Banner from "@/components/Banner";
import Footers from "@/components/Footer";
import NewsList from "./component/NewsList";

export default {
  name: "TeamIntroduction",
  components: {
    NavBar,
    Banner,
    Footers,
    NewsList,
  },
  data() {
    return {
      lange: this.$cookies.getCookie("language"),
      bannerList:{},
    };
  },
  created() {
    //滚动条到顶
    this.$BackTop();
    this.bannerImg();
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
  destroyed() {
    location.reload();
  },
  methods: {
     bannerImg (){
          this.bannerList = this.lange == "ch"
          ? {src:require('../../assets/images/banner_6.png'),srcmedban:require('../../assets/images/banner_6a.png')}
          : {src:require('../../assets/images/banner_6.png'),srcmedban:require('../../assets/images/banner_6a.png')}
          // : {src:require('../../assets/images/banner_2_e.png'),srcmedban:require('../../assets/images/banner_2_em.png')};
        },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  width: 100%;
  display: block;
  position: relative;
}
.footImg {
  width: 100%;
  display: block;
  margin-top: 60px;
}
.pcban {
  display: none;
  position: relative;
}
.pcban .text1{
  position: absolute;
  top: 32%;
  left:46%;
  font-size: 28px;
  color: #bda67d;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 400;
}
.pcban .text2{
  position: absolute;
  color: #fff;
  top: 45%;
  left: 46%;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 700;
  font-size: 34px;
}
.pcban .text3{
  position: absolute;
  color: #fff;  
  top: 57%;
  left: 46.5%;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 700;
  font-size: 24px;
}
.medban {
  display: none;
  position: relative;
}
.medban .text1{
  position: absolute;
  top: 30%;
  right:5%;
  font-size: 14px;
  color: #bda67d;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 400;
}
.medban .text2{
  position: absolute;
  color: #fff;
  top: 45%;
  right: 4%;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
.medban .text3{
  position: absolute;
  color: #fff;
  top: 58%;
  right: 5%;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 700;
  font-size: 14px;
}
.ywzs_title {
  width: 100%;
  display: block;
  text-align: center;
  font-size: 40px;
  color: #07566c;
  padding: 40px 0 60px 0;
  font-family: shsm, shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.ywzs_title > span {
  display: inline-block;
  position: relative;
  padding: 0 30%;
  font-family: shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.ywzs_img1,
.ywzs_img2 {
  width: 26%;
  height: 2px;
  display: block;
  position: absolute;
  top: 50%;
}
.ywzs_img1 {
  left: 0;
}
.ywzs_img2 {
  right: 0;
}
@media only screen and (max-width: 1920px) {
  .pcban {
    display: block;
  }
  .medban {
    display: none;
  }
}
@media only screen and (max-width: 425px) {
  .pcban {
    display: none;
  }
  .medban {
    display: block;
  }
  .ywzs_title {
    font-size: 18px;
    padding: 15px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/TeamIntroduction/index.vue